import { render, staticRenderFns } from "./EditProductSupplier.vue?vue&type=template&id=7540cff6&"
import script from "./EditProductSupplier.vue?vue&type=script&lang=js&"
export * from "./EditProductSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports